"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authSessionFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
const mocks_1 = require("../../../mocks");
exports.authSessionFactory = Factory.Sync.makeFactory({
    brand: null,
    email_address: 'test@example.com',
    email_on_create: null,
    invite_token: uuid_1.v4(),
    logout_urls: null,
    must_change_password: null,
    organization_name: mocks_1.orgNgb.name,
    primary_obfuscated_email: 't**t@e*****e.com'
});
